<template>
  <div>
    <v-card-title>
      <h3>Plan data</h3>
    </v-card-title>
    <v-divider></v-divider>

    <v-list>
      <v-list-tile ripple>
        <v-flex xs4 md2>
          <h5><b>Name</b></h5>
        </v-flex>
        <v-flex xs9 md10>
          {{ planData.name }}
        </v-flex>
      </v-list-tile>

      <v-list-tile ripple>
        <v-flex xs4 md2>
          <h5><b>Price</b></h5>
        </v-flex>
        <v-flex xs9 md10>
          {{ currencyFormat(quotationTotalPrice) }}
        </v-flex>
      </v-list-tile>

      <v-list-tile ripple>
        <v-flex xs4 md2>
          <h5><b>Wake Dates</b></h5>
        </v-flex>
        <v-flex xs9 md10>
          <span v-if="caseData.is_preplan">
            N/A (preplan)
          </span>
          <span v-else>
            {{ moment(caseData.wake_start).format('YYYY-MM-DD') }} - {{ caseData.wake_end ? moment(caseData.wake_end).format('YYYY-MM-DD') : 'not set' }}
          </span>
        </v-flex>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
  import plansAPI from '@/api/resources/plans'
  import casesAPI from '@/api/resources/cases'
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        planData: {},
        caseData: {},
        quotationTotalPrice: 0
      }
    },
    props: {
      plansid: {
        type: Number,
        required: true
      },
      casesid: {
        required: true
      }
    },
    computed: {
      ...mapGetters({
        getAllCases: 'getAllCases',
        caseById: 'getCaseById'
      })
    },
    watch: {
      getAllCases (cases) {
        this.caseData = cases.find(cas => cas.id === parseInt(this.casesid))
      }
    },
    created () {
      plansAPI.loadPlan(this.plansid).then(result => {
        this.planData = result
      })

      casesAPI.getQuotationTotalPrice(this.casesid).then(result => {
        this.quotationTotalPrice = result
      }, () => {})

      casesAPI.loadCase(this.casesid).then(result => {
        this.caseData = result
      }, () => {})
    },
    methods: {
      currencyFormat (number) {
        return 'SGD $' + number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CasePlanDataTable.vue?c1d34448